import { Pipe, PipeTransform } from '@angular/core';
import { EnvironmentType } from '@fleet-beat/core';
import { EnvironmentCheckService } from '../services/environment-check.service';

@Pipe({
  name: 'environmentCheck',
})
export class EnvironmentCheckPipe implements PipeTransform {
  constructor(private environmentCheckService: EnvironmentCheckService) {}

  transform(environments: EnvironmentType[], devQa?: boolean, stageProdDemo?: boolean): boolean {
    if (devQa) {
      return this.environmentCheckService.qaDev;
    }

    if (stageProdDemo) {
      return this.environmentCheckService.stageProdDemo;
    }

    return this.environmentCheckService.check(environments);
  }
}
